import React from 'react'
import { Title } from '@devexpress/dx-react-chart-material-ui'
import { useStyles } from './styles'
import Help from '@material-ui/icons/Help'

const titleStyle = { margin: 'auto' }
const TitleText = props => {
  const classes = useStyles()
  return (
    <div className={classes.titleContainer}>
      <div className={classes.text}>
        <Title.Text {...props} style={titleStyle} />
      </div>
      <div className={classes.icon}>
        <Help viewBox='0 0 26 26' titleAccess='This chart shows the number of stories tagged by tag type for a given wave of learners.' />
      </div>
    </div>
  )
}

export default TitleText
